<script>
import Title from '@components/section-title'
import { MODAL } from '@constants/Text'
import Color from '@constants/Color'

export default {
  components: {
    Title,
  },
  props: {
    bus: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      panels: [0],
      filtro_servicos: {
        nome_servico: '',
        tipo_taxa: '',
        valor_total_menor: '',
        valor_total_maior: '',
        qtd_clientes_menor: '',
        qtd_clientes_maior: '',
      },
      filtro_clientes: {
        nome: '',
        pl: '',
      },
    }
  },
  computed: {
    Color() {
      return Color
    },
  },
  created() {
    if (this.bus) {
      this.bus.$on(MODAL.FILTRO_SERVICOS, (v) => {
        this.bus.$emit('dialog', true)
      })
      this.bus.$on('clearFilters', (v) => {
        this.clearFilters()
        console.log('LIMPAR FILTROS')
      })
    }
  },
  methods: {
    filtrar(close) {
      this.bus.$emit('filtros', {
        filtro_servicos: this.filtro_servicos,
        filtro_clientes: this.filtro_clientes,
      })
      close()
    },
    clearFilters() {
      this.filtro_servicos = {
        nome_servico: '',
        tipo_taxa: '',
        valor_total_menor: '',
        valor_total_maior: '',
        qtd_clientes_menor: '',
        qtd_clientes_maior: '',
      }
      this.filtro_clientes = {
        nome: '',
        pl: '',
      }
      this.bus.$emit('clearFilters', {
        filtro_servicos: this.filtro_servicos,
        filtro_clientes: this.filtro_clientes,
      })
    },
  },
}
</script>

<template>
  <BaseModal :bus="bus" max-width="700px" height="670px">
    <div style="padding: 30px 34px 50px;">
      <Title
        title="Filtre sua pesquisa"
        subtitle="Use os filtros para melhorar sua pesquisa"
      />

      <div style="height: 350px; overflow: auto; padding-right: 5px">
        <div class="v-application">
          <v-expansion-panels v-model="panels" multiple>
            <v-expansion-panel style="background-color: var(--gray-2)">
              <v-expansion-panel-header class="v-application py-0">
                <h2 class="panel-title">Serviços</h2>
                <template v-slot:actions>
                  <v-icon color="primary">mdi-plus</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="v-application--is-ltr">
                <div class="row pt-0 align-items-center">
                  <div class="col-2 text-right text-sm">
                    Nome
                  </div>
                  <div class="col-5">
                    <div class="input-group">
                      <v-text-field
                        v-model="filtro_servicos.nome_servico"
                        class="input"
                        placeholder="Nome do serviço"
                        :background-color="Color['light_mode']['gray-1']"
                        solo
                        flat
                      />
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="input-group input-select">
                      <v-select
                        v-model="filtro_servicos.tipo_taxa"
                        class="input bg-gray-1"
                        placeholder="Taxa (% ou R$)"
                        :background-color="Color['light_mode']['gray-1']"
                        solo
                        flat
                        append-icon="mdi-chevron-down"
                        :items="['Taxa %', 'Taxa R$']"
                      />
                    </div>
                  </div>
                </div>
                <div class="row pt-0 align-items-center">
                  <div class="col-2 text-right text-sm">
                    Valor total
                  </div>
                  <div class="col-5">
                    <div class="input-group">
                      <v-text-field
                        v-model="filtro_servicos.valor_total_menor"
                        class="input bg-gray-1"
                        placeholder="Menor"
                        :background-color="Color['light_mode']['gray-1']"
                        solo
                        flat
                      />
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="input-group">
                      <v-text-field
                        v-model="filtro_servicos.valor_total_maior"
                        class="input bg-gray-1"
                        placeholder="Maior"
                        :background-color="Color['light_mode']['gray-1']"
                        solo
                        flat
                      />
                    </div>
                  </div>
                </div>
                <div class="row pt-0 align-items-center">
                  <div class="col-2 text-right text-sm">
                    Quantidade de clientes
                  </div>
                  <div class="col-5">
                    <div class="input-group">
                      <v-text-field
                        v-model="filtro_servicos.qtd_clientes_menor"
                        class="input bg-gray-1"
                        placeholder="Menor"
                        :background-color="Color['light_mode']['gray-1']"
                        solo
                        flat
                      />
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="input-group">
                      <v-text-field
                        v-model="filtro_servicos.qtd_clientes_maior"
                        class="input bg-gray-1"
                        placeholder="Maior"
                        :background-color="Color['light_mode']['gray-1']"
                        solo
                        flat
                      />
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel style="background-color: var(--gray-2)">
              <v-expansion-panel-header class="v-application py-0">
                <h2 class="panel-title">Clientes</h2>
                <template v-slot:actions>
                  <v-icon color="primary">mdi-plus</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="v-application--is-ltr">
                <div class="row pt-0 align-items-center">
                  <div class="col-6">
                    <div class="input-group">
                      <v-text-field
                        v-model="filtro_clientes.nome"
                        class="input bg-gray-1"
                        placeholder="Nome"
                        :background-color="Color['light_mode']['gray-1']"
                        solo
                        flat
                      />
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="input-group">
                      <v-text-field
                        v-model="filtro_clientes.pl"
                        class="input bg-gray-1"
                        placeholder="P/L"
                        :background-color="Color['light_mode']['gray-1']"
                        solo
                        flat
                      />
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close">
        Cancelar
      </BaseButton>
      <BaseButton primary @click="filtrar(close)">
        Filtrar
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>


